<template>

    <div id="preCourses">

        <v-container fluid>
            <v-row>
              <v-col cols="12">
                <span>Class Reference: </span> <strong>{{model.classReference}}</strong>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    label="Attendee Select Feedback URL"
                    :value="model.selectFeedBackLink"
                    readonly
                />
              </v-col>
                <v-col cols="12">
                    <v-text-field
                            label="Attendee Post-Course URL"
                            :value="model.attendeePostCourseUrl"
                            readonly
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                            label="Trainer Post-Course URL"
                            :value="model.trainerPostCourseUrl"
                            readonly
                    />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12"><h2>Attendee Feedback</h2></v-col>
                <v-col cols="12" v-for="postCourse in model.feedbackDelegates" :key="postCourse.id">
                    <v-card >
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title  class="headline">{{postCourse.firstName}} {{postCourse.lastName}} {{scoreFeedback(postCourse)}}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-chip
                                            dark
                                            :color="scoreToColour(scoreFeedback(postCourse))"
                                            label
                                    >
                                        {{scoreToLabel(scoreFeedback(postCourse))}}
                                    </v-chip>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        <v-card-text>
                        <v-row>
                            <v-col cols="4 " v-for="ratingGroup in  ratingGroups" :key="ratingGroup">
                                <v-card flat>
                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title  class="headline">{{ratingGroup.title}}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item v-for="question in ratingGroup.questions" :key="question">
                                            <v-list-item-content>
                                                <v-list-item-title>{{question.title}}:</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-chip
                                                        dark
                                                        :color="scoreToColour(postCourse['answer' + question.answerNumber])"
                                                        label
                                                        >
                                                    {{scoreToLabel(postCourse['answer' + question.answerNumber])}}
                                                </v-chip>
                                            </v-list-item-action>
                                        </v-list-item>

                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-row>
                        </v-card-text>

                        <v-card-text>
                            <v-textarea
                                    class="mx-2"
                                    label="Comments"
                                    rows="5"
                                    readonly
                                    outlined
                                    :value="postCourse.comments"
                            ></v-textarea>
                            <v-textarea
                                    class="mx-2"
                                    label="Further Courses Required"
                                    rows="5"
                                    readonly
                                    outlined
                                    :value="postCourse.furtherCourses"
                            ></v-textarea>
                        </v-card-text>
                    </v-card>
                    <v-divider/>
                </v-col>
            </v-row>
        </v-container>
    </div>

</template>

<script>

    export default {

        props: {
            model: Object,
        },

        data() {
            return {
                ratingGroups: [

                    {
                        title: "Course",
                        questions: [
                            {title: "Achievement of your objectives", answerNumber: 2},
                            {title: "Length and pace of course", answerNumber: 3},
                            {title: "Relevance of course content", answerNumber: 4},
                        ]
                    },
                    {
                        title: "Trainer",
                        questions: [
                            {title: "Knowledge of subject", answerNumber: 5},
                            {title: "Clarity of explanations and answers", answerNumber: 6},
                            {title: "Response to delegate's needs", answerNumber: 7},
                        ]
                    },
                    {
                        title: "Overall",
                        questions: [
                            {title: "Overall rating for the course", answerNumber: 0},
                        ]
                    },
                ]
            }
        },


        filters: {
            scoreToCol34or(value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        methods: {

            scoreFeedback(feedback){
                return Math.round((feedback.answer0
                    + feedback.answer2
                    + feedback.answer3
                    + feedback.answer4
                    + feedback.answer5
                    + feedback.answer6
                    + feedback.answer7) / 7)
            },

            scoreToColour(score) {

                const map = ['green', 'light-green', 'orange', 'red']
                return map[score-1];
            },

            scoreToLabel(score) {
                const map = ['Excellent', 'Good', 'Ok', 'Poor']
                return map[score-1];
            },


            mapAnswer4(number) {
                const map = ['Regularly', 'Occasionally', 'Used older version', 'Not at all']
                return map[number - 1]
            },
            mapAnswer1(number) {
                const map = ['Windows', 'Mac', 'Other', 'None']
                return map[number - 1]
            },


        }


    }

</script>